import { DecryptedAES } from "../common/DecryptedAES";

export const processEncryptedResponse = async (res) => {
  const encryptedPayload = res?.payload;

  if (!encryptedPayload) return null;

  const decryptedString = await DecryptedAES(encryptedPayload);

  if (!decryptedString) return null;

  const decryptedData = JSON.parse(decryptedString);

  if (!decryptedData) return null;

  return decryptedData.data;
};
